import { styles } from './ServiceIcon.css';
import Tick from '@jbhi-fi/lanyard-ui/components/Icons/Tick';
import { ServiceIds } from '../../../../../utils/constants/services';
import React from 'react';

interface IconProps {
  imageUrl?: string;
  size?: number;
  selected?: boolean;
  offeringType?: string;
}

export const ServiceIcon = ({ imageUrl, size, selected, offeringType = undefined }: IconProps) => {
  const isMobileExtra = ServiceIds.MobileExtras === offeringType;
  return (
    <div className={styles.serviceIconWrap} style={{ width: size, height: size }}>
      {!!selected && isMobileExtra ? <Tick tickFill="#ffffff" className={styles.tick} /> : null}
      <img alt="Service offering icon" className={styles.icon} src={imageUrl} width={size} height={size} />
    </div>
  );
};
